// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"03d1030f","160":"cc41f36e","259":"f4f9b033","453":"76473624","498":"c9198590","562":"8472b941"}[chunkId] + ".chunk.js";
};